import React, { useEffect, useState } from 'react';
import { CardBody, Card, Col, Container, Row, Input, Label, Modal, Button, Form, FormFeedback, FormGroup } from "reactstrap";
import apiGlobal from '../global/api.global';
import AsyncSelect from 'react-select/async';
import * as Yup from "yup";
import { useFormik, FormikProvider, ErrorMessage, Field, FieldProps } from "formik";
import Layout from '../HorizontalMenu/Menu';
import Navbar from '../HorizontalMenu/Navbar';
import '../global/GlobalCSS.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '..';
import { VesselState, getVesselsAction, setVesselState, setVesselID } from "../Store/Generic/ReportingSlice";
import VesselAdditionalInformation from './AdditionalInformation/AdditionalInformation';
import ToolTip from '../Components/ToolTip';
import VesselConfiguration from './VesselConfiguration/VesselConfiguration';
import VoyageIcon from '../Media/voyage.png'
import VoyageInformation from '../VoyageInformation/VoyageInformation';
import VesselReportingInfo from '../VesselReportingInfo/VesselReportingInfo';
import DeckOfficerWizard from '../ReportingWizard/DeckOfficerReport/DeckOfficerReporting';
import EngineerWizard from '../ReportingWizard/EngineerReport/EngineerReporting';
import CreateVoyage from '../VoyageInformation/CreateVoyage';
import { loadUserVessel, load_Vessel_Sub_Types, load_Vessel_Types } from './vesselMaster.hooks';
import { successToast } from '../Components/Toasts';
import EditVesselReport from '../VesselReportingInfo/EditVesselReport';
import { customStyle } from 'shared/CommonCSS';
import CreateVesselReport from 'VesselReportingInfo/CreateVesselReport';
import { Roles } from 'shared/constants';
import { hasRole } from 'utils/auth/authUtils';
import Select from 'react-select';
import { TooltipMsg } from 'Components/ToolTipMessage';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';


const VesselMaster = () => {
    /** State variable start  */
    const [modal_xlarge, setmodal_xlarge] = useState(false);
    const { Vessels, VesselState } = useSelector((state: RootState) => state.Reporting);
    const [data, setData] = useState({
        vessel_name: '',
        vessel_type_name: '',
        vessel_sub_type_name: '',
        IMO_number: '',
        ice_class: '',
        is_sts_applicable: false
    })
    const [vessels, setVessels] = useState<Array<any>>([]);
    const dispatch = useDispatch();
    /** State variable end */

    /** Queries */
    /** Vessel assigned to user  */
    const { data: UserVessel }:
        { data: any[], isLoading: any, isError: any } = useQuery(
            [queryKeyes.vessel.UserVessel.key],
            async () => {
                return await loadUserVessel();
            },
            { staleTime: Infinity }
        );
    /** Queries end */

    /** useEffect start */
    useEffect(() => {
        dispatch(getVesselsAction('vessel_master' as string));
    }, [dispatch]);
    useEffect(() => {
        let arr: any = []
        if (hasRole(Roles.MASTER)) {
            Vessels?.map((vessel: any, index: any) => {
                if ((UserVessel?.filter((item: any) => item.constant === Roles.MASTER)[0]?.vessel.includes(vessel.id))) {
                    arr.push(vessel);
                }
                return vessel;
            })
        } else if (hasRole(Roles.CHIEFENGINEER)) {
            Vessels?.map((vessel: any, index: any) => {
                if ((UserVessel?.filter((item: any) => item.constant === Roles.CHIEFENGINEER)[0]?.vessel.includes(vessel.id))) {
                    arr.push(vessel);
                }
                return vessel;
            })
        } else {
            arr = Vessels;
        }
        setVessels(arr);
    }, [Vessels, UserVessel, dispatch])
    /** useEffect end */
    // console.log(UserVessel)

    /** set vessel id & state globally */
    const handleVesselState = (row: number, record: VesselState) => {
        dispatch(setVesselID(row))
        dispatch(setVesselState(record))
    }

    /** Open-close modal */
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge);
        removeBodyCss();
    }

    /** Types of ice class */
    const iceClassOptions = [
        { id: "IC", label: "IC" },
        { id: "IB", label: "IB" },
        { id: "IA", label: "IA" },
        { id: "IA super", label: "IA super" },
        { id: "NA", label: "NA" }
    ]

    // Form validation 
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            vessel_name: '',
            IMO_number: '',
            vessel_type_name: '',
            vessel_sub_type_name: '',
            ice_class: '',
            is_sts_applicable: false
        },
        validationSchema: Yup.object({
            vessel_name: Yup.string().matches(
                /^[A-Za-z ]{1,50}$/, "Please enter upto 50 alphabets only"
            ).required("Please enter the vessel name"),
            IMO_number: Yup.string().matches(
                /^[0-9]{7,8}$/, "Please enter upto 8 digits only"
            ).required("Please enter IMO number"),
            vessel_type_name: Yup.string().required("Please select the vessel type name"),
            vessel_sub_type_name: Yup.string().required("Please select the vessel sub type name"),
        }),
        onSubmit: (values) => {
        }
    })

    const handle_Textbox_Changes = (event: any, validation: any) => {
        validation.handleChange(event);
        handle_Textbox(event);
    }

    function handle_Textbox(e: any) {
        const newdata: any = { ...data }
        newdata[e.target.name] = e.target.value
        setData(newdata)
    }

    function Vessel_Master_Submit(e: any) {
        apiGlobal.post(`/vessel_master/`, data).then(res => {
            tog_xlarge();
            successToast("Data saved successfully!");
        })
            .catch(err => {
            });
    }


    return (
        <>
            <React.Fragment>
                {VesselState === null &&
                    <>
                        <Layout children={Navbar} />
                        <div className="page-content">
                            <Container fluid>
                                <div className='ele_row'>
                                    <h4 className='mb-3'>Vessel List</h4>
                                    {(hasRole(Roles.ES_ADMIN)) && <button
                                        type="button"
                                        className="btn btn-primary waves-effect waves-light mb-3"
                                        data-toggle="modal"
                                        data-target=".bs-example-modal-xl"
                                        onClick={() => {
                                            tog_xlarge();
                                        }}
                                    >
                                        <i className="dripicons-plus font-size-16 align-middle me-2"></i>{" "}
                                        Add New
                                    </button>}
                                    <Modal
                                        size="xl"
                                        isOpen={modal_xlarge}
                                        toggle={() => {
                                            tog_xlarge();
                                        }}
                                    >
                                        <div className="modal-header">
                                            <h5
                                                className="modal-title mt-0"
                                                id="myExtraLargeModalLabel"
                                            >
                                                Add New
                                            </h5>
                                            <button
                                                onClick={() => {
                                                    setmodal_xlarge(false);
                                                }}
                                                type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <FormikProvider value={validation}>
                                                <Form className="needs-validation" autoComplete="off"
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation.handleSubmit();
                                                        Vessel_Master_Submit(e);
                                                        return false;
                                                    }}
                                                >
                                                    <Card>
                                                        <CardBody>
                                                            <Row>
                                                                <Col lg={4}>
                                                                    <FormGroup className="mb-3">
                                                                        <Label for="vessel_name" className='asteric mb-0'>Vessel name</Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="vessel_name"
                                                                            name="vessel_name"
                                                                            onChange={(e: any) => handle_Textbox_Changes(e, validation)}
                                                                            value={validation.values.vessel_name}
                                                                            invalid={
                                                                                validation.touched.vessel_name && validation.errors.vessel_name ? true : false
                                                                            }
                                                                        />
                                                                        {validation.touched.vessel_name && validation.errors.vessel_name ? (
                                                                            <FormFeedback type="invalid">{validation.errors.vessel_name}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg={4}>
                                                                    <div className="mb-3">
                                                                        <Label for="IMO_number" className='asteric mb-0'>IMO number</Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="IMO_number"
                                                                            name='IMO_number'
                                                                            onChange={(e: any) => handle_Textbox_Changes(e, validation)}
                                                                            value={validation.values.IMO_number}
                                                                            invalid={
                                                                                validation.touched.IMO_number && validation.errors.IMO_number ? true : false
                                                                            }
                                                                        />
                                                                        {validation.touched.IMO_number && validation.errors.IMO_number ? (
                                                                            <FormFeedback type="invalid">{validation.errors.IMO_number}</FormFeedback>
                                                                        ) : null}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg={4}>
                                                                    <FormGroup className="mb-3">
                                                                        <div className="mb-3">
                                                                            <Label className='asteric mb-0'>Select vessel type</Label><br></br>
                                                                            <Field name={`vessel_type_name`}>
                                                                                {({ field }: FieldProps) => (
                                                                                    <AsyncSelect
                                                                                        name={field.name}
                                                                                        cacheOptions
                                                                                        defaultOptions
                                                                                        loadOptions={load_Vessel_Types}
                                                                                        getOptionLabel={(e: any) => e.vessel_type_name}
                                                                                        getOptionValue={(e: any) => e.id}
                                                                                        onChange={(e: any) => data.vessel_type_name = e.id}
                                                                                        styles={customStyle}
                                                                                        menuPortalTarget={document.querySelector('.MuiDialog-root')}

                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                            {validation.errors.vessel_type_name ?
                                                                                <ErrorMessage name='vessel_type_name' component="span" className="error" /> : null}
                                                                        </div>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg={4}>
                                                                    <FormGroup className="mb-3">
                                                                        <div className="mb-3">
                                                                            <Label className='asteric mb-0'>Select vessel sub type</Label><br></br>
                                                                            <Field name={`vessel_sub_type_name`}>
                                                                                {({ field }: FieldProps) => (
                                                                                    <AsyncSelect
                                                                                        name={field.name}
                                                                                        cacheOptions
                                                                                        defaultOptions
                                                                                        loadOptions={load_Vessel_Sub_Types}
                                                                                        getOptionLabel={(e: any) => e.vessel_sub_type_name}
                                                                                        getOptionValue={(e: any) => e.id}
                                                                                        onChange={(e: any) => data.vessel_sub_type_name = e.id}
                                                                                        menuPortalTarget={document.querySelector('.MuiDialog-root')}
                                                                                        styles={customStyle}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                            {validation.errors.vessel_sub_type_name ?
                                                                                <ErrorMessage name='vessel_sub_type_name' component="span" className="error" /> : null}
                                                                        </div>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg={4}>
                                                                    <Label className='mb-0'>Select vessel's ice class</Label>
                                                                    <Field name={`ice_class `}>
                                                                        {({ field }: FieldProps) => (<Select
                                                                            options={iceClassOptions}
                                                                            getOptionLabel={option => option.label}
                                                                            getOptionValue={option => option.id}
                                                                            onChange={(e: any) => data.ice_class = e.id}
                                                                        />
                                                                        )}
                                                                    </Field>
                                                                </Col>
                                                                <Col lg={4}>
                                                                    <div className="d-flex flex-wrap gap-2 mb-3">
                                                                        <Label className='mt-2 w-15'>Is this vessel STS applicable?
                                                                            <i className='bx bx-info-circle ml-2p' id='is_sts_applicable_msg' />
                                                                        </Label>
                                                                        <ToolTip
                                                                            target='is_sts_applicable_msg'
                                                                            message={`${TooltipMsg.CreateReport
                                                                                .filter((item: any) => item.target === 'is_sts_applicable_msg')
                                                                                .map((tool: any) => { return tool.message })
                                                                                }`}
                                                                        />
                                                                        <Field name={`is_sts_applicable `}>
                                                                            {({ field, form }: FieldProps) => (
                                                                                <div className="square-switch sqswitch ml-1 mt-1">
                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        switch="none"
                                                                                        name={field.name}
                                                                                        id="is_sts_applicable "
                                                                                        onChange={(e: any) => form.setFieldValue(field.name, e.target.checked)}
                                                                                    />
                                                                                    <Label
                                                                                        htmlFor="is_sts_applicable "
                                                                                        data-on-label='Yes'
                                                                                        data-off-label='No'
                                                                                        className='mt-1'>
                                                                                    </Label>
                                                                                </div>
                                                                            )}
                                                                        </Field>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <div className="d-flex flex-wrap gap-5 grp_justify_right">
                                                                    <Button type="submit" color="primary" className='btn_size4_5_cstm'>Save</Button>
                                                                    <Button type="reset" color="danger" className='btn_size4_5_cstm'>Reset</Button>
                                                                </div>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Form>
                                            </FormikProvider>
                                        </div>
                                    </Modal>
                                </div>
                                <CardBody>
                                    <div className="table-responsive" id='owner_table'>
                                        <table className="table mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Vessel name</th>
                                                    <th>Vessel type</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {vessels.filter((item: any) => item.display === true).length > 0 ?
                                                    vessels.filter((item: any) => item.display === true).map((vessel: any, index: number) => (
                                                        <tr key={vessel.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{vessel.vessel_name}</td>
                                                            <td>{vessel.vessel_type}</td>
                                                            <td>
                                                                {hasRole(Roles.ES_ADMIN) &&
                                                                    <>
                                                                        <ToolTip target='additional_information' message='Additional information' />
                                                                        <button
                                                                            className="btn no-border"
                                                                            onClick={() => { handleVesselState(vessel.id, 'ADDITIONAL_INFO') }}>
                                                                            <i className='bx bx-info-circle mr-2 icon_s18' id='additional_information'></i>
                                                                        </button></>}
                                                                {hasRole(Roles.ES_ADMIN) &&
                                                                    <>
                                                                        <ToolTip target='vessel_configuration' message='Vessel configuration' />

                                                                        <button className="btn no-border">
                                                                            <i className='bx bx-cog mr-2 icon_s18' id='vessel_configuration' onClick={() => { handleVesselState(vessel.id, 'VESSEL_CONFIG') }}></i>
                                                                        </button>
                                                                    </>
                                                                }
                                                                {(
                                                                    hasRole(Roles.ES_ADMIN) ||
                                                                    hasRole(Roles.MASTER) ||
                                                                    hasRole(Roles.CHIEFENGINEER) ||
                                                                    hasRole(Roles.MANAGER)
                                                                ) &&
                                                                    <>
                                                                        <ToolTip target='voyage_reporting' message='Voyage reporting' />
                                                                        <img
                                                                            alt="Voyage"
                                                                            src={VoyageIcon}
                                                                            height="35"
                                                                            className='mr-2 pointer'
                                                                            id="voyage_reporting"
                                                                            onClick={() => { handleVesselState(vessel.id, 'VOYAGE_REPORTING') }} />
                                                                    </>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))
                                                    : <tr>
                                                        <td colSpan={4}>Loading Vessels...</td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Container>
                        </div>
                    </>
                }
            </React.Fragment>
            {VesselState === 'ADDITIONAL_INFO' && <VesselAdditionalInformation />}
            {VesselState === 'VESSEL_CONFIG' && <VesselConfiguration />}
            {VesselState === 'VOYAGE_REPORTING' && <VoyageInformation />}
            {VesselState === 'CREATE_VOYAGE_REPORTING' && <CreateVoyage />}
            {VesselState === 'VESSEL_REPORTING' && <VesselReportingInfo />}
            {VesselState === 'CREATE_VESSEL_REPORTING' && <CreateVesselReport />}
            {VesselState === 'DO_REPORTING' && <DeckOfficerWizard />}
            {VesselState === 'ENGG_REPORTING' && <EngineerWizard />}
            {VesselState === 'EDIT' && <EditVesselReport />}
        </>
    )
}

export default VesselMaster;